import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import OfferListForm from "./OfferListForm";
import { useSearchParams, useNavigate } from "react-router-dom";
import { getActiveOfferTypes, getOfferTypes } from "../../api/OfferType";
import {
  adnPageSize,
  appTitle,
  dateFormat,
  Departement,
  OfferStatus,
  WorkPlaces,
} from "../common/GeneralConfigurations";
import {
  getEmployeeOfferList,
  getEmployeeOffersExcel,
  updateEmployeeOffer,
} from "../../api/EmployeeOfferApi";
import moment from "moment";
import { AppRoutes } from "../../AppRoutes";
import { Form } from "antd";
import AdnMessageError from "../common/adnMessage/AdnMessageError";
import AdnMessageSuccess from "../common/adnMessage/AdnMessageSuccess";
import { GetUserByDepartmentId } from "../../api/UserApi";

const ManageOfferListPage = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [formOffers] = Form.useForm();
  const REPORT_NAME = t("offer.reports.employeesOffers");

  const currentMonth = new Date().getMonth() + 1;
  const currentYear = new Date().getFullYear();

  const offerTypeId = searchParams.get("offerType")
    ? parseInt(searchParams.get("offerType"))
    : "";
  const offerTypeMonth = searchParams.get("month")
    ? searchParams.get("month")
    : "";
  const offerTypeYear = searchParams.get("year")
    ? searchParams.get("year")
    : "";

  const [orderBy, setOrderBy] = useState("");
  const [typeId, setTypeId] = useState(offerTypeId);
  const [totalRecords, setTotalRecords] = useState(0);
  const [employeeName, setEmployeeName] = useState("");
  const [description, setDescription] = useState("");
  const [pageNumber, setpageNumber] = useState(1);
  const [employeeOfferList, setEmployeeOfferList] = useState([]);
  const [typeOfferList, setTypeOfferList] = useState([]);
  const [offerStatus, setOfferStatus] = useState(0);
  const [loading, setLoading] = useState(true);
  const [month, setMonth] = useState(offerTypeMonth !== "" ? offerTypeMonth : currentMonth);
  const [year, setYear] = useState(offerTypeYear !== "" ? offerTypeYear : currentYear);
  const [editMode, setEditMode] = useState(false);
  const [offerToEdit, setOfferToEdit] = useState({});
  const [modalSubmitLoading, setModalSubmitLoading] = useState(false);
  const [offerFormValues, setOfferFormValues] = useState();
  const [cancelOfferVisible, setCancelOfferVisible] = useState(false);
  const [managerId, setManagerId] = useState([]);
  const [managersList, setManagersList] = useState([]);

  const [cancelOfferForm] = Form.useForm();

  useEffect(() => {
    document.title = `${appTitle} - ${t("offer.title")}`;
    const offerTypes = async () => {
      await getOfferTypes().then((res) => {
        setTypeOfferList(res.data);
      });
    };

    offerTypes();
    getManagersList();

    navigate(AppRoutes.offerList.path);
  }, [navigate]);

  const getEmployeeOffers = useCallback(async () => {
    await getEmployeeOfferList(
      pageNumber,
      adnPageSize,
      orderBy,
      typeId !== "" ? typeId : "",
      employeeName,
      description,
      offerStatus,
      month,
      year,
      managerId
    )
      .then((res) => {
        setEmployeeOfferList(res.data.result);
        setTotalRecords(res.data.totalRecords);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [
    pageNumber,
    orderBy,
    typeId,
    employeeName,
    description,
    offerStatus,
    month,
    year,
    managerId,
  ]);

  useEffect(() => {
    getEmployeeOffers();
  }, [
    typeId,
    offerStatus,
    description,
    employeeName,
    pageNumber,
    orderBy,
    month,
    year,
    managerId,
    getEmployeeOffers,
  ]);

  const handleOfferDate = async (offerDate, offerData) => {
    if (offerDate != null) {
      let updatedOffer = {
        status: 1,
        id: offerData.id,
        employeeId: offerData.employeeId,
        typeId: offerData.typeId,
        offeredAt: offerDate,
        note: offerData.note,
        offerName: offerData.offerName,
        referenceDate: offerData.referenceDate,
        description: offerData.description,
      };
      await updateEmployeeOffer(updatedOffer).then((res) => {
        if (res.status === 200) {
          AdnMessageSuccess();
          getEmployeeOffers();
        } else {
          AdnMessageError(t("offer.messages.couldNotUpdateOffer"));
        }
      });
    }
  };

  const handleOrderList = (pag, filter, sorter) => {
    sorter.order === "descend"
      ? setOrderBy("-" + sorter.field.toLowerCase())
      : sorter.order === "ascend"
      ? setOrderBy(sorter.field.toLowerCase())
      : setOrderBy("");
  };

  const offerTypeChange = (value) => {
    setpageNumber(1);
    if (value !== undefined) {
      setTypeId(value);
    } else {
      setTypeId(0);
    }
  };

  const monthHandleChange = (value) => {
    setpageNumber(1);
    if (value !== undefined) {
      setMonth(value);
    } else {
      setMonth("");
    }
  };

  const yearHandleChange = (value) => {
    setpageNumber(1);
    if (value !== undefined) {
      setYear(value);
    } else {
      setYear("");
    }
  };

  const offerStatusHandleChange = (value) => {
    setpageNumber(1);
    if (value !== undefined) {
      setOfferStatus(value);
    } else {
      setOfferStatus(-1);
    }
  };

  const handleSearchDescription = (value) => {
    if (value.length >= 3) {
      setDescription(value);
      setpageNumber(1);
    } else {
      setDescription("");
    }
  };

  const handleSearchEmployeeName = (value) => {
    if (value.length >= 3) {
      setEmployeeName(value);
      setpageNumber(1);
    } else {
      setEmployeeName("");
    }
  };

  const ShowEditModal = (record) => {
    if (record.offeredAt === null) {
      record.offeredAt = null;
    } else {
      record.offeredAt = moment(record.offeredAt, dateFormat);
    }
    setOfferToEdit({ ...record });
    formOffers.setFieldsValue({ ...record });
    setEditMode(true);
  };

  const CancelEditModal = () => {
    setEditMode(false);
  };

  const handleCancelOfferModal = (values) => {
    setOfferFormValues(values);
    setCancelOfferVisible(true);
  };

  const handleChangeOffer = async (values, status) => {
    let canceledOffer = {
      id: values.id,
      employeeId: values.employeeId,
      typeId: values.typeId,
      offeredAt: status === 0 ? null : values.offeredAt,
      note: status === 0 ? "" : cancelOfferForm.getFieldValue("note"),
      offerName: values.offerName,
      referenceDate: values.referenceDate ? values.referenceDate : null,
      description: values.description,
      status: status,
    };
    await updateEmployeeOffer(canceledOffer).then(async (res) => {
      if (res.status === 200) {
        AdnMessageSuccess();
        await getEmployeeOffers();
        setCancelOfferVisible(false);
      } else {
        AdnMessageError(t("offer.messages.couldNotChangeOfferStatus"));
      }
    });
  };

  const EditOfferHandler = async (values) => {
    values.offeredAt === null || values.offeredAt === ""
      ? (values.status = OfferStatus.NotDelivered)
      : (values.status = OfferStatus.Delivered);
    values.id = offerToEdit.id;
    values.employeeId = offerToEdit.employeeId;
    await updateEmployeeOffer(values)
      .then(async ({ data }) => {
        setModalSubmitLoading(true);
        if (data.success === true) {
          AdnMessageSuccess();
          await getEmployeeOffers();
        } else {
          AdnMessageError(data.errors[0].message);
        }
      })
      .catch((errors) => {
        AdnMessageError(errors.message);
      })
      .finally(() => {
        setEditMode(false);
        setModalSubmitLoading(false);
      });
  };

  const disabledDateOffer = (current) => {
    if (
      moment().year() < current.year() ||
      moment().year() - current.year() > 1
    )
      return true;

    if (moment().year() - current.year() <= 0) {
      if (moment().month() < current.month()) return true;

      if (moment().month() === current.month()) {
        if (moment().date() < current.date()) return true;
      }
    }
    return false;
  };

  const getRowClassName = (record, index) => {
    const workPlaceIdToCheck =
      record.managerWorkPlaceId !== 0
        ? record.managerWorkPlaceId
        : record.workPlaceId;
    return workPlaceIdToCheck === WorkPlaces.Porto ? "porto-bcolor" : "";
  };

  const handleChangeManager = (value) => {
    if (value === undefined) {
      setManagerId([]);
    } else {
      setManagerId(value);
    }
  };

  const getManagersList = async () => {
    GetUserByDepartmentId(Departement.Manager).then((res) => {
      if (res.status === 200) {
        const filteredManagers = res.data.result.filter(
          (manager) => manager.deleted === false
        );
        setManagersList(filteredManagers);
      }
    });
  };

  const handleEmployeeOffersExcel = async () => {
    await getEmployeeOffersExcel(
      pageNumber,
      adnPageSize,
      orderBy,
      offerTypeId !== "" ? offerTypeId : typeId,
      employeeName,
      description,
      offerStatus,
      offerTypeMonth !== "" ? offerTypeMonth : month,
      offerTypeYear !== "" ? offerTypeYear : year,
      managerId
    )
      .then((res) => {
        if (res.status === 200) {
          const url = window.URL.createObjectURL(
            new Blob([res.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            })
          );
          const a = document.createElement("a");
          a.href = url;
          a.download = `${REPORT_NAME}.xlsx`;
          a.click();
          window.URL.revokeObjectURL(url);
        } else if (res && res.data && res.data.errors) {
          res.data.errors.map((e) => {
            return AdnMessageError(e.message);
          });
        } else {
          return AdnMessageError(t("offer.messages.couldNotGenerateReport"));
        }
      })
      .catch(() => {
        return AdnMessageError(t("offer.messages.couldNotGenerateReport"));
      });
  };

  return (
    <OfferListForm
      employeeOfferList={employeeOfferList}
      currentPage={pageNumber}
      pageSize={adnPageSize}
      handleChangePage={setpageNumber}
      typeOfferList={typeOfferList}
      offerTypeChange={offerTypeChange}
      offerStatusHandleChange={offerStatusHandleChange}
      handleSearchDescription={handleSearchDescription}
      handleSearchEmployeeName={handleSearchEmployeeName}
      loading={loading}
      totalRecords={totalRecords}
      handleOrderList={handleOrderList}
      handleMonthChange={monthHandleChange}
      handleYearChange={yearHandleChange}
      typeId={typeId}
      month={month}
      year={year}
      EditOfferHandler={EditOfferHandler}
      editMode={editMode}
      ShowEditModal={ShowEditModal}
      CancelEditModal={CancelEditModal}
      offerToEdit={offerToEdit}
      formOffers={formOffers}
      modalSubmitLoading={modalSubmitLoading}
      disabledDateOffer={disabledDateOffer}
      handleChangeOffer={handleChangeOffer}
      offerStatus={offerStatus}
      handleOfferDate={handleOfferDate}
      handleCancelOfferModal={handleCancelOfferModal}
      cancelOfferVisible={cancelOfferVisible}
      setCancelOfferVisible={setCancelOfferVisible}
      cancelOfferForm={cancelOfferForm}
      offerFormValues={offerFormValues}
      getRowClassName={getRowClassName}
      handleChangeManager={handleChangeManager}
      managersList={managersList}
      handleEmployeeOffersExcel={handleEmployeeOffersExcel}
    />
  );
};

export default ManageOfferListPage;
